<template>
    <ValidationProvider
        :vid="vid"
        :rules="rules"
        :name="label"
        v-slot="{ errors }"
        tag="div"
        class="form-group"
        :class="{ 'form-group-compact': compact }"
    >
        <label v-if="label && !hideLabel">{{ label }}<span v-if="required" class="text-danger">*</span></label>
        <elastic-textarea
            :placeholder="placeholder ? placeholder : label"
            :value="value"
            @input="handleInput"
            :style="{ 'min-height': (minHeight > 0 ? minHeight + 'px' : 'auto') }"
            class="form-control"
            :disabled="disabled"
            :class="{ 'border-danger': (errors.length > 0) }"
            :rows="rows"
            :strip-tags="stripTags"
        />
        <span class="validation-invalid-label">{{ getInvalidFeedback(errors) }}</span>
    </ValidationProvider>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import ElasticTextarea from '@components/ElasticTextarea';

export default {
    name: 'TextareaWithValidation',
    props: {
        vid: null,
        rules: {
            type: [String, Object, Array],
            default: '',
        },
        value: null,
        label: String,
        hideLabel: {
            type: Boolean,
            default: false,
        },
        placeholder: String,
        minHeight: Number,
        rows: {
            type: Number,
            default: 2,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        compact: {
            type: Boolean,
            default: false,
        },
        stripTags: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        ElasticTextarea,
        ValidationProvider,
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value);
        },
        getInvalidFeedback(errors, key = null) {
            if (key) {
                if (Array.isArray(errors[key]) && errors[key].length) {
                    return errors[key].join(', ');
                }
            }

            if (Array.isArray(errors) && errors.length) {
                return errors.join(', ');
            }

            return null;
        },
    },
    computed: {
        required() {
            if (this.rules instanceof Object) {
                return this.rules.required ?? false;
            }
            return this.rules.includes('required');
        },
    },
};
</script>

<style>
.form-group.form-group-compact {
    margin-bottom: 0.625rem;
}
.form-group.form-group-compact .col-form-label, .form-group.form-group-compact label {
    margin-bottom: 0.25rem;
}
</style>
